import { Icon, IconItem } from './icon.definitions';
import { StatusKind } from './status-label.definitions';

export enum AnnouncementKind {
    AutomaticTranslations = 'AutomaticTranslations',
    CreditCardExpires = 'CreditCardExpires',
    Offline = 'Offline',
    Impersonating = 'Impersonating',
    PaymentFailed = 'PaymentFailed',
    TrialExpiry = 'TrialExpiry',
    PracticeTimer = 'PracticeTimer',
    MileageTracker = 'MileageTracker',
    GettingStartedGuide = 'GettingStartedGuide'
}

export enum AnnouncementMode {
    Default = 'Default',
    Tracker = 'Tracker'
}

export enum BannerMode {
    Stacked = 'Stacked',
    Inline = 'Inline'
}

export interface IAnnouncement {
    Announcement: AnnouncementKind;
    Kind: StatusKind.Danger | StatusKind.Brand | StatusKind.Warning | StatusKind.Light;
    Priority: number;
    Mode: AnnouncementMode;
    Icon: IconItem;
    Dismissible: boolean;
}

export const AnnouncementByKind: Record<AnnouncementKind, IAnnouncement> = {
    [AnnouncementKind.AutomaticTranslations]: {
        Announcement: AnnouncementKind.AutomaticTranslations,
        Icon: Icon.Common.Translate,
        Kind: StatusKind.Brand,
        Priority: 5,
        Mode: AnnouncementMode.Default,
        Dismissible: true
    },
    [AnnouncementKind.CreditCardExpires]: {
        Announcement: AnnouncementKind.CreditCardExpires,
        Icon: Icon.Common.Warning,
        Kind: StatusKind.Warning,
        Priority: 3,
        Mode: AnnouncementMode.Default,
        Dismissible: true
    },
    [AnnouncementKind.Offline]: {
        Announcement: AnnouncementKind.Offline,
        Icon: Icon.Common.WifiOff,
        Kind: StatusKind.Danger,
        Priority: 1,
        Mode: AnnouncementMode.Default,
        Dismissible: false
    },
    [AnnouncementKind.Impersonating]: {
        Announcement: AnnouncementKind.Impersonating,
        Icon: Icon.Common.NewRelease,
        Kind: StatusKind.Brand,
        Priority: 6,
        Mode: AnnouncementMode.Default,
        Dismissible: false
    },
    [AnnouncementKind.PaymentFailed]: {
        Announcement: AnnouncementKind.PaymentFailed,
        Icon: Icon.Common.Info,
        Kind: StatusKind.Danger,
        Priority: 2,
        Mode: AnnouncementMode.Default,
        Dismissible: false
    },
    [AnnouncementKind.TrialExpiry]: {
        Announcement: AnnouncementKind.TrialExpiry,
        Icon: Icon.Common.Warning,
        Kind: StatusKind.Warning,
        Priority: 4,
        Mode: AnnouncementMode.Default,
        Dismissible: true
    },
    [AnnouncementKind.PracticeTimer]: {
        Announcement: AnnouncementKind.PracticeTimer,
        Icon: Icon.Common.TimerOutline,
        Kind: StatusKind.Light,
        Priority: 99,
        Mode: AnnouncementMode.Tracker,
        Dismissible: false
    },
    [AnnouncementKind.MileageTracker]: {
        Announcement: AnnouncementKind.MileageTracker,
        Icon: Icon.Common.Odometer,
        Kind: StatusKind.Light,
        Priority: 100,
        Mode: AnnouncementMode.Tracker,
        Dismissible: false
    },
    [AnnouncementKind.GettingStartedGuide]: {
        Announcement: AnnouncementKind.GettingStartedGuide,
        Icon: Icon.Common.NewRelease,
        Kind: StatusKind.Brand,
        Priority: 1,
        Mode: AnnouncementMode.Default,
        Dismissible: true
    },
};
